import * as IzendaActionType from './constants';

const defaultIzendaState = {
  ActiveTenant: null,
  Dashboards: null
};

export default function IzendaStore(state = defaultIzendaState, action) {
  switch (action.type) {
    case IzendaActionType.GET_ACTIVE_TENANTS_SUCCESS:
      return {
        ...state,
        ActiveTenant: action.data
      };
    case IzendaActionType.SEARCH_DASHBOARD_SUCCESS:
      return {
        ...state,
        Dashboards: action.data
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/izenda/reducers.js